<template>
  <AdminLayout>
    <Head title="Biotrack Inventory Look-Up" />

    <div class="headline flex flex-col md:flex-row justify-between items-start md:items-center mx-4 sm:mx-12">
      <h2 class="text-2xl font-semibold text-blue-600">Biotrack Inventory Look-Up</h2>

      <div class="relative inline-flex self-start my-5">
        <div class="input-group mr-2">
          <input
            type="text"
            v-model="form.source_id"
            placeholder="Inventory ID"
          />
        </div>

        <button
          v-if="inventory"
          @click="postInventory(inventory)"
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
        >
          Sync
        </button>
      </div>
    </div>

    <!-- Page is loading with results -->
    <div
      class="mx-4 sm:mx-12"
      v-if="loading"
    >
      Loading...
    </div>

    <JsonData
      v-if="inventory && !loading"
      :json="inventory"
      :id="1"
    />
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link } from '@inertiajs/vue3'
import { ChevronDownIcon, ArrowCircleDownIcon } from '@heroicons/vue/solid'
import interactsWithCurrentLocation from '@/Mixins/interactsWithCurrentLocation'
import MultiSelectInput from '@/Components/Forms/MultiSelectInput'
import accessesCompany from '@/Mixins/accessesCompany'
import JsonData from '@/Components/JsonData.vue'

export default {
  mixins: [interactsWithCurrentLocation, accessesCompany],

  components: {
    JsonData,
    AdminLayout,
    Head,
    Link,
    ChevronDownIcon,
    ArrowCircleDownIcon,
    MultiSelectInput
  },

  props: {
    inventory: Object,
    params: Object
  },

  data() {
    return {
      loading: true,
      form: this.$inertia.form({
        source_id: this.params.source_id ?? null
      })
    }
  },

  created() {
    this.loading = false
  },

  watch: {
    'form.source_id': function (newVal, oldVal) {
      this.update()
    }
  },

  methods: {
    update: _.debounce(
      function () {
        this.loading = true

        this.form.get(route('integrations.biotrack.inventory.show'))
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),

    postInventory(inventory) {
      if (!window.confirm('Are you sure you want to post?')) {
        return
      }

      axios
        .post(route('integrations.biotrack.inventory.store'), {
          source_id: inventory.ID
        })
        .then((response) => {
          console.log(response)
        })
    }
  }
}
</script>
